import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RCore from 'RCore';
import UI from 'UI';
import color from 'color';
import _ from 'lodash';
import SMTeamLogo from '../SMTeamLogo';

//These lines are needed to get common i18
const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const TblContainer = styled.table`
    border-collapse: separate;
    border-spacing: 0 2px;
    width: 100%;
`;

const TH = styled.td`
    text-align: center;
    line-height: 28px;
    color: ${props => props.theme.color};
    background-color: ${props => props.theme.content.accentColor};
    font-weight: ${props => props.theme.fonts.main.bold};
    padding-left: ${props => props.paddingLeft};
`;

const TD = styled.td`
    font-size: 18px;
    line-height: 40px;
    text-align: ${props => (props.left ? 'left' : 'center')};
    padding-left: ${props => props.paddingLeft};
    font-weight: ${props => props.theme.fonts.main.bold};

    &.wdp-nowrap {
        white-space: nowrap;
    }
    div {
        display: flex;
        align-items: center;
    }
    .wdp-team-logo {
        margin-right: 15px;
    }
`;

const QualRelTR = styled.tr`
    position: relative;
    color: ${props => (props.high ? props.theme.content.accentTextColor : props.theme.color)};
    background-color: ${props => (props.high ? props.theme.content.accentColor : props.theme.content.backgroundColor)};
    font-weight: ${props => props.theme.fonts.main.bold};

    td {
        position: relative;
        color: ${props => (props.high ? props.theme.content.accentTextColor : props.theme.color)};
        font-weight: ${props => props.theme.fonts.main.bold};

        .rel-badge {
            display: inline-block;
            background-color: ${props =>
                (props.type && color(props.theme.qualRelColors[props.type]).toString()) ||
                color(props.theme.content.backgroundColor)
                    .alpha(0.3)
                    .rgb()
                    .toString()};
            width: 21px;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
        }
    }
`;

const Row = ({ row, qualRel, highlight, tournamentId }, ctx) => {
    const lang = _.get(ctx, 'info.lang', 'en');

    return (
        <QualRelTR key={row.rank} type={qualRel && row.rankType} high={highlight}>
            <TD width="70px" paddingLeft={qualRel && 20}>
                {qualRel && <span className="rel-badge" />}
                {row.rank}
            </TD>
            <TD width="450px" left>
                <div>
                    <SMTeamLogo tournamentId={tournamentId} teamId={row.teamId} width={28} height={28} />
                    {row.teamName}
                </div>
            </TD>
            <TD width="70px">{row.matchesPlayed}</TD>
            <TD width="70px" className="wdp-nowrap">
                {row.goalsScored + ' - ' + row.goalsConceded}
            </TD>
            <TD width="70px">{row.points}</TD>
        </QualRelTR>
    );
};

const Header = ({ qualRel }, ctx) => {
    const lang = _.get(ctx, 'info.lang', 'en');

    return (
        <tr>
            <TH width="70px" paddingLeft={qualRel && 20} className="__c__b1_style1"><span className="__c__c1_style1">#</span></TH>
            <TH className="__c__b1_style1" />
            <TH className="__c__b1_style1"><span className="__c__c1_style1">{i18('matches.short', lang)}</span></TH>
            <TH className="__c__b1_style1"><span className="__c__c1_style1">{i18('goals.short', lang)}</span></TH>
            <TH className="__c__b1_style1"><span className="__c__c1_style1">{i18('points.short', lang)}</span></TH>
        </tr>
    );
};

Row.contextTypes = {
    info: PropTypes.object,
    teamLogoSettings: PropTypes.object
};

Header.contextTypes = {
    info: PropTypes.object,
    teamLogoSettings: PropTypes.object
};

const Container = ({ children }) => (
    <TblContainer>
        <tbody>{children}</tbody>
    </TblContainer>
);

export default { Header, Row, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/tables/MainTT.js
 **/